/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendFeedbackDto } from '../../models/backend-feedback-dto';
import { BackendFeedbackRequestDto } from '../../models/backend-feedback-request-dto';

export interface FeedbackCreateCreate$Params {
  body: BackendFeedbackRequestDto;
}

export function feedbackCreateCreate(
  http: HttpClient,
  rootUrl: string,
  params: FeedbackCreateCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendFeedbackDto>> {
  const rb = new RequestBuilder(rootUrl, feedbackCreateCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendFeedbackDto>;
    }),
  );
}

feedbackCreateCreate.PATH = '/api/feedback/create/';
